<div [ngClass]="footerContainerCssClasses" class="d-flex flex-column flex-md-row flex-stack">
  <!-- begin::Copyright  -->
  <div class="text-dark order-2 order-md-1">
    <span class="text-muted fw-bold me-2">{{ currentDateStr }} &copy;</span>
    <a href="https://mobiletic.com/fr/" class="text-gray-800 text-hover-primary cursor-pointer" target="_blank"> mobiletic </a>
  </div>
  <!-- end::Copyright  -->

  <!-- begin::Nav  -->
  <ul class="menu menu-gray-600 menu-hover-primary fw-bold order-1">
<!--    <li class="menu-item">-->
<!--      <a routerLink="/help" routerLinkActive="active" class="menu-link ps-0 pe-2 cursor-pointer" > {{"MenuDashboard.propos" | translate}} </a>-->
<!--    </li>-->
    <li class="menu-item">
      <a  routerLink="/users/conditions/cgUser" class="menu-link pe-0 pe-2 cursor-pointer" > {{"MenuDashboard.contact" | translate}} </a>
    </li>
<!--    <li class="menu-item">-->
<!--      <a href="/help" class="menu-link pe-0 cursor-pointer" > {{"MenuDashboard.help" | translate}} </a>-->
<!--    </li>-->
  </ul>
  <!-- end::Nav  -->
</div>
